<template>
  <div class="center">
    <div class="title">
      {{ newData.name }}
    </div>
    <div class="zp_details">
      <el-row>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <el-breadcrumb separator="|">
              <el-breadcrumb-item
                >{{ label_author }} ：{{ newData.username }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >{{ label_name }}：{{
                  newData.activity_id == 1001
                    ? newData.filed_2
                    : newData.department
                    ? newData.department
                    : newData.from
                }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >发表时间：{{ newData.created_at }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <index-icons
              @clickMark="clickMark"
              :activityId="newData.activity_id"
              :workId="newData.id"
              :goodsnum="marks"
              :ShowComment="ShowComment"
              :commentnum="comment"
              :looknum="views"
            ></index-icons>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="zp_text">
      <div class="box">
        <!-- <video  
            class="video" 
            controls 
            preload="none" 
            poster="http://video-js.zencoder.com/oceans-clip.png"
            data-setup="{}">
          <source :src="`${(videoUrl)}`" type='video/mp4' />
        </video> -->
        <div class="demo">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </div>
        <div class="text">{{ newData.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import IndexIcons from "@/components/Icons";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  name: "VideoDetails",
  components: {
    IndexIcons,
    videoPlayer
  },
  props: ["videoDetails", "activityId", "ShowComment"],
  data() {
    return {
      newData: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" // url地址
          }
        ],
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      marks: "",
      comment: "",
      views: ""
    };
  },
  watch: {
    //正确给 newData 赋值的 方法
    videoDetails: function(newVal, oldVal) {
      this.newData = newVal; //newVal即是chartData
      console.log("监听props改变");
      console.log(newVal);
      console.log(this.playerOptions.sources[0].src);
      this.playerOptions.sources[0].src = newVal.file;
      this.marks = newVal.mark;
      this.comment = newVal.comment;
      this.views = newVal.views;
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player; //自定义播放
    },
    label_name() {
      let id = this.activityId;
      if (+id === 426 || id == 1001) {
        return `参赛者单位`;
      } else {
        return "参赛机构";
      }
    },
    label_author() {
      let id = this.activityId;
      if (+id === 426 || id == 1001) {
        return `参赛者姓名`;
      } else {
        return "作者";
      }
    },
    isShowComment() {
      return this.activityId == 426 ? false : true;
    }
  },

  methods: {
    clickMark() {
      this.marks = parseInt(this.marks) + 1;
    }
  },
  created() {
    //
  }
};
</script>
<style scoped>
.box {
  width: 100%;
  background: white;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
}
.center {
  width: 1200px;
  margin: 20px auto;
}
.center .title {
  height: 26px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 30px 0px;
}

.grid-content >>> .comment_icons {
  margin: 0px;
  width: 100%;
  text-align: right !important;
}

.zp_text {
  width: 1200px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin: 20px 0px;
  padding: 40px 50px;
  box-sizing: border-box;
}

.text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  white-space: break-spaces;
}
video {
  width: 1080px;
  height: 540px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/workdetails/components/video.vue